<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="widgets"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="content_category_order rounded-lg mx-3">
        <v-col class="mx-3" cols="8">
          <div class="">
            <h4 class="mr-3 mt-3 float-left">Order ID: #{{order.id}}</h4>
            <v-select
                class="float-left mr-3"
                outlined
                :items="status"
                item-text="text"
                item-value="value"
                v-model="select_status"
                :placeholder="select_status"
            ></v-select>
            <v-text-field
                class="float-left mr-3"
                readonly
                outlined
                :value="delevery"
            >
            </v-text-field>
            <v-text-field
                readonly
                outlined
                :value="formatDate(order.created_at)"
            >
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="12" class="mx-3">
          <v-row>
            <v-col cols="2">
              Họ tên:
            </v-col>
            <v-col cols="10" >
              {{ order && order.fullname ? order.fullname: ''}}
            </v-col>
            <v-col cols="2">
              SĐT:
            </v-col>
            <v-col cols="10" >
              {{ order && order.phone ? order.phone: ''}}
            </v-col>

            <v-col cols="2">
              Yêu cầu khác:
            </v-col>
            <v-col cols="10" >
              {{ order && order.message ? order.message: ''}}
            </v-col>
                <v-col cols="2">
                  <span>Địa chỉ: </span>
                </v-col>
                <v-col cols="10">
                  <span> {{ order && order.address ? order.address: ''}}</span>
                </v-col>
                <v-col cols="2">
                  <span>Giảm giá (vnđ): </span>
                </v-col>
                <v-col cols="10">
                  <span class="blue--text"> {{ order && order.discount_price ? formatCurrency(order.discount_price): 0}}</span>
                </v-col>
                <v-col cols="2">
                  <span class="font-weight-bold">Tổng tiền (vnđ): </span>
                </v-col>
                <v-col cols="10">
                  <h3 class="red--text"> {{ order && order.total_price ? formatCurrency(order.total_price): ''}}</h3>
                </v-col>
              </v-row>
        </v-col>
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="order.order_items"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.photo_url="{ item }" >
              <v-img width="100" :src="item.photo_url ? item.photo_url : require('@/assets/images/bi_image.png')"/>
            </template>
            <template v-slot:item.price="{ item }" >
             <span class="red--text">{{formatCurrency(item.price)}}</span>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" class="text-center mb-10" v-if="hasPermissions('Update order')">
          <v-btn
              width="130"
              color="primary"
              @click="save"
          >
            Lưu
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_DETAIL_ORDER, UPDATE_ORDER } from "@/store/modules/order";
import {mapGetters} from "vuex";
import FormatPrice from '@/mixins/formatPrice'

export default {
  mixins:[FormatPrice],
  data() {
    return {
      page: "Quản lý đơn hàng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý đơn hàng",
          disabled: true,
        },
        {
          text: "Chi tiết đơn hàng",
          disabled: true,
        },
      ],
      headers: [
        { text: 'Tên sản phẩm', value: 'name' , align:'start'},
        { text: 'Ảnh', value: 'photo_url' },
        { text: 'Số lượng', value: 'quantity' },
        { text: 'Giá (vnđ)', value: 'price' },
      ],
      id:'',
      status: [
        {
          value : 0 ,
          text : 'Chưa xác nhận'
        },
        {
          value : 1 ,
          text : 'Đã xác nhận'
        },
        {
          value : 2 ,
          text : 'Đang giao hàng'
        },
        {
          value : 3 ,
          text :  'Đã giao hàng'
        }
        ,{
          value :4 ,
          text :  'Đã hủy'
        }
      ],
      select_status1:'',
      select_status:'',
      delevery: '',
      status1:'',
    };
  },
  computed: {
    ...mapGetters({
      order: "orderDetail"
    })
  },
  watch: {
    order() {
      this.select_status = this.order.status;
      if(this.order.delivery_type === 1) {
        this.delevery = 'Nhận tại siêu thị'
      }
      else {
        this.delevery = 'Địa chỉ giao hàng'
      }
    }
  },
created() {
  this.id = this.$route.params.id
  this.$store.dispatch(GET_DETAIL_ORDER, this.id)
},
  methods:{
    formatCurrency(price) {
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(parseInt(price));
    },
    formatDate(date) {
      if (!date) return null
      let newDate = new Date(date)
      const [year, month, day] = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()];
      let day_format = day > 9 ? day : `0${day}`
      let month_format = month > 9 ? month : `0${month}`

      return `${day_format}/${month_format}/${year}`
    },
    editItem(){},
    reviewItem() {
      this.$router.push('/manage_productions/category/detail_category')
    },
    deleteItem(){},
    save(){
      console.log(this.select_status,'sss')
      this.$store.dispatch(`${UPDATE_ORDER}`, {
        status: this.select_status,
        id: this.id
      }).then((data)=>{
        if (data.data.status === 1) {
          this.$toasted.success('Cập nhật thành công', {
            position: "top-center",
            theme: "toasted-primary",
            duration :2000
          });
          this.$router.push('/management_order')
        }
      });
    }

  }
};
</script>
<style lang="scss">
.content_category_order {
  background: #ffffff !important;
  .v-input__slot {
    width: 250px;
  }
  .v-text-field__slot input {
    text-align: center;
  }
}
</style>